export const config = {
  API_URL:
    process.env.REACT_APP_API_URL ??
    "https://client-service.dev.lexcare.in/api/v1",
  // API_URL:'https://client-service1.lexcare.ai/api/v1',
  AUTH_SHARED_KEY:
    process.env.REACT_APP_AUTH_SHARED_KEY ??
    "WESeElSN8dd6rc1OIhefLhQArgg7yo7iDMa2dwo4zq4u7kYl6",
  SOURCE: process.env.REACT_APP_SOURCE ?? "uattestclient.dev.lexcare.in",
  //   SOURCE:'qa-clientapp.lexcare.in'
};
